/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../sub2/common';
import '../../../common/time';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "Subscription": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "planToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "planName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "status": {
                        "type": "squareup.sub2.common.SubscriptionStatus",
                        "id": 4,
                        "rule": "optional"
                      },
                      "freeTrialEndAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE Subscription @ squareup/solidshop/v2/resources/subscription.proto at 11:1
 */
export const Subscription = $root.lookupType('squareup.solidshop.v2.resources.Subscription');
fixType(Subscription);
Builder.createAndAttachToType(Subscription);
